import clsx from 'clsx'
import { IDropdownProps } from './types'
import styles from './styles.module.scss'
import { useRef, useState } from 'react'
import {
  FloatingArrow,
  FloatingFocusManager,
  arrow,
  autoUpdate,
  flip,
  offset,
  shift,
  useClick,
  useDismiss,
  useFloating,
  useInteractions,
  useRole,
} from '@floating-ui/react'

const Dropdown = ({ children, position = 'top', size = 'md', trigger }: IDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const arrowRef = useRef(null)

  const arrowHeight = 9
  const arrowWidth = 14

  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    middleware: [
      offset(arrowHeight),
      flip(),
      shift(),
      arrow({
        element: arrowRef,
      }),
    ],
    whileElementsMounted: autoUpdate,
    placement: position,
  })

  const click = useClick(context)
  const dismiss = useDismiss(context)
  const role = useRole(context)

  const { getReferenceProps, getFloatingProps } = useInteractions([click, dismiss, role])

  return (
    <>
      <span ref={refs.setReference} {...getReferenceProps()}>
        {trigger}
      </span>
      {isOpen && (
        <>
          <FloatingFocusManager context={context} modal={false}>
            <div
              ref={refs.setFloating}
              style={floatingStyles}
              {...getFloatingProps()}
              className={clsx('mui-dropdown', styles[size])}
            >
              <FloatingArrow
                className={styles.arrow}
                context={context}
                height={arrowHeight}
                ref={arrowRef}
                tipRadius={2}
                width={arrowWidth}
              />
              {children}
            </div>
          </FloatingFocusManager>
        </>
      )}
    </>
  )
}

export default Dropdown
